<header id="stickyHeader" class="stick-nonDisplay">
  <div class="stickyBg">
    <div class="container-main">
      <div id="header">
        <div class="social">
          <app-social-yatay01 *ngIf="sosyalMedya" [sosyalMedya]="sosyalMedya"></app-social-yatay01>
          <div class="tarih">{{tarih}}</div>
        </div>
        <div class="logoWrap">
          <div class="logo">
            <a routerLink="/"> <img [src]="firma?.logo"
              alt="{{firma?.slogan}}"></a>
          </div>
        </div>
        <div class="menuBut">
          <a routerLink="/canli-izle" class="cnlTV" >  <i class="fa fa-play mr-5"></i> CANLI TV</a>
          <!-- <a  class="rounded-btn tv264Red" routerLink="/canli-izle">CANLI</a> -->
          <a type="text" id="menuButton" aria-expanded="Yan Menu Aç" (click)="leftMenu=true" label="Menu Aç"><i
              class="fal fa-bars"></i></a>
        </div>


      </div>
    </div>
  </div>


  <nav id="menuTop" class="menuTop stickyMenu-spc">
    <ul>
      <li><a  (click)="ProgramMenu = true">PROGRAMLAR</a></li>
      <li><a routerLink="/haftalik-yayin-programi">YAYIN AKIŞI</a></li>
      <li><a class="c-yayin tv264Red" routerLink="/canli-izle">CANLI YAYIN</a></li>
      <li><a routerLink="/iletisim">TV264</a></li>
      <li><a (click)="rightMenu = true" >DİĞER</a></li>

    </ul>
    <i class="fal fa-search ml-5" (click)="aramaMenu = true"></i>

  </nav>

</header>

<header id="normalHeader">
  <div class="container-main">
    <div id="header">
      <div class="social">
        <app-social-yatay01 [sosyalMedya]="sosyalMedya"></app-social-yatay01>
        <div class="tarih">{{tarih}}</div>
      </div>
      <div class="logoWrap">
        <div class="logo">
          <a routerLink="/"> <img [src]="firma?.logo"
              alt="{{firma?.slogan}}"></a>
        </div>
      </div>
      <div class="menuBut">
        <a routerLink="/canli-izle" class="cnlTV" >  <i class="fa fa-play mr-5"></i> CANLI TV</a>
        <!-- <a  class="rounded-btn tv264Red" routerLink="/canli-izle">CANLI</a> -->
        <a type="text" id="menuButton" aria-expanded="Yan Menu Aç" (click)="leftMenu=true" label="Menu Aç"><i
            class="fal fa-bars"></i></a>
      </div>
    </div>
  </div>


</header>


<nav class="menuTop">
  <ul>
    <li><a  (click)="ProgramMenu = true">PROGRAMLAR</a></li>
    <li><a routerLink="/kurumsal/2/haftalik-yayin-programi">YAYIN AKIŞI</a></li>
    <li><a class="c-yayin tv264Red" routerLink="/canli-izle">CANLI YAYIN</a></li>
    <li><a routerLink="/iletisim">TV264</a></li>
    <li><a (click)="rightMenu = true" >DİĞER</a></li>
    <i class="fal fa-search ml-5" (click)="aramaMenu = true"></i>
  </ul>
</nav>
<!-- <div class="fixedHeight"></div> -->
<!-- Fixed Height Static Header Top Fix -->


<main class="d-flex justify-center">

  <div class="leftSide">
<!--    <a href="https://medyabar.com/service/advertclick?channel=7690&amp;advert=18633" target="_blank">
      <img src="https://static.daktilo.com/sites/302/uploads/2023/03/09/ezgifcom-optimize-2%20(1).gif" alt="">
    </a> 

    <a href="https://medyabar.com/service/advertclick?channel=7690&amp;advert=25728" target="_blank">
      <img src="https://static.daktilo.com/sites/302/uploads/2023/03/24/dikey-bannner.jpg" alt="">
    </a>  -->
  </div>







  <div class="container bg-white spc-pt20 pb-20 ml-20 mr-20 ">

    <router-outlet></router-outlet>

  </div>

  <div class="rightSide">
<!-- 
    <a href="https://medyabar.com/service/advertclick?channel=7690&amp;advert=18633" target="_blank">
      <img src="https://static.daktilo.com/sites/302/uploads/2023/03/09/ezgifcom-optimize-2%20(1).gif" alt="">
    </a> 

    <a href="https://medyabar.com/service/advertclick?channel=7690&amp;advert=25728" target="_blank">
      <img src="https://static.daktilo.com/sites/302/uploads/2023/03/24/dikey-bannner.jpg" alt="">
    </a>  -->
  </div>
</main>



<footer>
  <br>
  <div class="logo">
    <a routerLink="/"> <img [src]="firma?.logo" 
        alt="Sakarya'nın İlk uydu Televizyonu"></a>
  </div>
  <div class="social">
    <app-social-yatay01 [sosyalMedya]="sosyalMedya"></app-social-yatay01>
  </div>
  <nav id="menuBottom">
    <ul>
      <li><a  (click)="ProgramMenu = true">PROGRAMLAR</a></li>
      <li><a routerLink="/kurumsal/2/haftalik-yayin-programi">YAYIN AKIŞI</a></li>
      <li><a class="c-yayin tv264Red" routerLink="/canli-izle">CANLI YAYIN</a></li>
      <li><a class="c-yayin tv264Red" href="https://medyabar.com/">MEDYABAR</a></li>
      <li><a routerLink="/iletisim">TV264</a></li>
      <li><a (click)="rightMenu = true">DİĞER</a></li>

    </ul>

  </nav>
  <div id="footerPowerappTop" class="left relative">

    <a class="app_app r1"  routerLink="/gizlilik-ilkesi">Gizlilik ilkesi</a>
    <a class="app_app r1"  routerLink="/kvkk">KVKK (6698)</a>
    <a class="app_app"  routerLink="/privacy-policy">Privacy Policy</a>

  </div>
  <br>
  <div id="footerPowerapp" class="left relative">

    <a class="app_app r1" target="_blank" href="https://apps.apple.com/us/app/tv264/id1584102077"><img src="./../../assets/images/apple-store.png"
        alt="Tv264 Apple Store"></a>
    <a class="goog_app" target="_blank" href="https://play.google.com/store/apps/details?id=com.buradatv.tv264androidtv"><img src="./../../assets/images/google-play.png"
        alt="Tv264 Google Play"></a>

  </div>
  <div id="copyright" class="copyright font-size-10">poweredBy digi[SOFT]</div>
</footer>




<!-- Left Side -->
<p-sidebar id="menuSidebar" styleClass="ui-sidebar-sm"   class="dark-nav" [(visible)]="leftMenu">
  <h2>Tv264 MENU</h2>
  <div id="searchButtonSpc" (click)="leftMenu = false"  (click)="aramaMenu = true">
     <span> ARA</span> <i class="fal fa-search ml-5" ></i>
  </div>

  <ul>
    <li >  <a routerLink="/" (click)="leftMenu = false">Anasayfa</a></li>
    <li >  <a  class="menu-red" >Programlar</a></li>
    <li >  
      <a routerLink="/program/{{item?.seoUrl}}" class="ml-10" (click)="leftMenu = false" *ngFor="let item of programlar">{{item?.ad}}</a>
    </li>
    <li >  <a routerLink="/kurumsal/2/haftalik-yayin-programi" (click)="leftMenu = false">Yayın Akışı</a></li>
    <li >  <a routerLink="/iletisim" (click)="leftMenu = false">Tv264</a></li>
    <li >  <a  (click)="leftMenu = false ; rightMenu=true">Kurumsal</a></li>
    <br>
    <li >  <a  target="_blank" rel="noopener noreferrer" href="https://wa.me/905336150224?text=Merhaba.Bir konuda bilgi paylaşmak istiyorum."  >Whatsapp İhbar Hattı</a></li>

  </ul>

  <div class="bottom-social">
    <app-social-yatay01 [sosyalMedya]="sosyalMedya"></app-social-yatay01>
  </div>
</p-sidebar>

<!-- Right Side -->
<p-sidebar id="netpolSideBar" [(visible)]="rightMenu" class="dark-nav" styleClass="ui-sidebar-sm" position="right">
  <h2>KURUMSAL</h2>
  <ul>
    <li >  <a routerLink="/kurumsal/{{item?.id}}/{{item?.seoUrl}}" (click)="rightMenu = false" *ngFor="let item of netpol">{{item?.ad}}</a></li>
  </ul>
</p-sidebar>

<!-- Right Program Side -->
<p-sidebar id="progSidebar" [(visible)]="ProgramMenu" class="dark-nav" styleClass="ui-sidebar-sm" position="left">
  <h2>PROGRAMLAR</h2>
  <ul>
    <li >  <a routerLink="/program/{{item?.seoUrl}}" (click)="ProgramMenu = false" *ngFor="let item of programlar">{{item?.ad}}</a></li>
  </ul>
</p-sidebar>


<p-sidebar [(visible)]="aramaMenu"  styleClass="ui-arama" [fullScreen]="true">
  <span class="ui-float-label inpt">
    <input id="float-input" type="text" (keyup.enter)="ara()"  [(ngModel)]="aranacakData" size="30" pInputText> 
    <label for="float-input">ARA</label>
<small>Aramak için enter tuşuna basın</small>

</span>
<i class="fal fa-times-circle fa-2x" (click)="[aramaMenu = false , aranacakData = '']" ></i>
<div class="sideBtnclose"></div>

</p-sidebar>
